export const projects = [
  {
    slug: "kenyon-road-lands",
    name: "Kenyon Estate Lot Development",
    location: "Municipality of North Glengarry",
    region: "County of Glengarry, Eastern Ontario",
    type: "Land Development — Deposited Plan of Survey",
    status: "Plan deposited — January 6, 2026",
    summary:
      "A deposited plan of survey defining three parcels fronting on Kenyon Road in the Township of North Glengarry.",
    description:
      "Stelcore Development acquired this property and managed the full development process in coordination with the Municipality of North Glengarry, transforming it into 3 estate building lots. Each lot was individually serviced with hydro and underwent comprehensive land clearing and site preparation for future construction. The completed project delivered three accessible, serviced lots ready for residential construction.",
    planNumber: "14R-6881",
    surveyPlan: "/assets/projects/survey-14r6881-full.png",
    surveyFull: "/assets/projects/survey-14r6881-full.png",
    altText:
      "Plan of survey 14R-6881 of part of Lot 22, Concession 1, Township of North Glengarry, showing three defined parts",
    overview: [
      "This project involved a full plan of survey of part of Lot 22, Concession 1, in the geographic Township of Kenyon, now within the Township of North Glengarry, County of Glengarry.",
      "The plan defines three parts fronting on Kenyon Road (Kenyon Concession Road 1), adjacent to the road allowance between the geographic townships of Kenyon and Charlottenburgh.",
      "The survey was completed on December 23, 2025, and Plan 14R-6881 was received and deposited on January 6, 2026 in the Land Titles Division of Glengarry (No. 14).",
    ],
    facts: [
      { label: "Plan Number", value: "14R-6881" },
      { label: "Legal Description", value: "Part of Lot 22, Concession 1" },
      { label: "Municipality", value: "Township of North Glengarry" },
      { label: "Geographic Township", value: "Kenyon" },
      { label: "County", value: "Glengarry" },
      { label: "Parcels Defined", value: "Three parts" },
      { label: "Parcel Areas", value: "3.28 ha / 3.18 ha / 3.16 ha" },
      { label: "Total Area", value: "9.62 ha (≈ 23.8 acres, converted)" },
      { label: "Road Frontage", value: "Kenyon Road (Concession Road 1)" },
      { label: "Surveyor", value: "Andrejs Luciks, O.L.S. — IBW Surveyors" },
      { label: "Survey Completed", value: "December 23, 2025" },
      { label: "Plan Deposited", value: "January 6, 2026" },
    ],
    progression: [
      { step: "Original Land", detail: "Part of Lot 22, Concession 1, geographic Township of Kenyon" },
      { step: "Development Strategy", detail: "Evaluation of the property and definition of parcel structure" },
      { step: "Survey & Design", detail: "Full plan of survey prepared by an Ontario Land Surveyor" },
      { step: "Defined Parcels", detail: "Three parts defined — 3.28 ha, 3.18 ha and 3.16 ha" },
      { step: "Plan Deposited", detail: "Plan 14R-6881 deposited in the Land Titles Division of Glengarry (No. 14)" },
    ],
  },
  {
    slug: "diversion-road",
    name: "Diversion Estate Lot Development",
    location: "Municipality of North Glengarry",
    region: "County of Glengarry, Eastern Ontario",
    type: "Land Development — Plan of Survey",
    status: "Survey completed — July 27, 2024",
    summary:
      "A plan of survey defining two parts fronting on Diversion Road in the geographic Township of Kenyon.",
    description:
      "Stelcore Development purchased the property and successfully obtained municipal approval from the Municipality of North Glengarry to create two estate building lots. Following approval, Stelcore completed the required site improvements, including land clearing, site preparation, installation of dedicated hydro services to each lot, and construction of aggregate driveways providing direct access from the municipal road. The project successfully delivered two hydro-serviced, accessible, and construction-ready estate lots for future residential development.",
    planNumber: "A-049206",
    surveyPlan: "/assets/projects/survey-diversion-road-full.png",
    surveyFull: "/assets/projects/survey-diversion-road-full.png",
    altText:
      "Plan of survey of part of the East 3/4 of Lot 35, Concession 3, Township of Kenyon, showing two defined parts on Diversion Road",
    overview: [
      "This project involved a plan of survey of part of the East 3/4 of Lot 35, Concession 3, in the geographic Township of Kenyon, County of Glengarry.",
      "The plan defines two parts fronting on Diversion Road — formerly King's Highway 43 — each with approximately 36.6 metres of road frontage and depths of approximately 186.6 to 186.9 metres, as measured on the plan.",
      "The survey was completed on July 27, 2024 and certified by E.R. Garden, Ontario Land Surveyor, of IBW Surveyors.",
    ],
    facts: [
      { label: "Plan Reference", value: "A-049206" },
      { label: "Address", value: "18578 Diversion Road" },
      { label: "Legal Description", value: "Part of East 3/4 of Lot 35, Concession 3" },
      { label: "Geographic Township", value: "Kenyon" },
      { label: "County", value: "Glengarry" },
      { label: "Parcels Defined", value: "Two parts" },
      { label: "Frontage per Part", value: "≈ 36.6 m on Diversion Road" },
      { label: "Depth per Part", value: "≈ 186.6 – 186.9 m" },
      { label: "Road", value: "Diversion Road (formerly King's Highway 43)" },
      { label: "Surveyor", value: "E.R. Garden, O.L.S. — IBW Surveyors" },
      { label: "Survey Completed", value: "July 27, 2024" },
    ],
    progression: [
      { step: "Original Land", detail: "Part of the East 3/4 of Lot 35, Concession 3, Township of Kenyon" },
      { step: "Development Strategy", detail: "Evaluation of the property and definition of parcel structure" },
      { step: "Survey & Design", detail: "Plan of survey prepared by an Ontario Land Surveyor" },
      { step: "Defined Parcels", detail: "Two parts defined with frontage on Diversion Road" },
      { step: "Survey Completed", detail: "Survey completed July 27, 2024 and certified by the O.L.S." },
    ],
  },
];

export const getProject = (slug) => projects.find((p) => p.slug === slug);
